import React from 'react';
import { T } from '../../../../utils/I18n/I18n';
import { useQuery } from '@apollo/client';
import { COUNTRIES } from '../queriesAddress';

const CountrySelect = ({register, errors, defaultCountry='HR'}) => {
    const { data: countries, loading } = useQuery(COUNTRIES);

    return (
        <>
            <label className="input-field__label" htmlFor="country">
                <T id="address.country" />
            </label>

            <select
                {...register('country_code', {
                    required: true,
                })}
                required
                errors={errors}
                className="form__select"
                name="country_code"
                id="country_code"
                defaultValue={defaultCountry}
            >
                <option value=""></option>
                {!loading && countries.countries.map(({id, full_name_locale}) => (
                    <option key={id} value={id}>{full_name_locale}</option>
                ))}
            </select>
            {errors?.country_code && ( // Zabezpieczenie przed undefined
                <span className="input-field__error">
          {errors.country_code.type === 'required' ? (
              <T id="formInput.required" />
          ) : (
              errors.country_code.message
          )}
        </span>
            )}
        </>
    )
};

export default CountrySelect;